export function RecentInvoicesSection({ onSeeAll }: { onSeeAll: () => void }) {
  return (
    <div>
      <div className="mb-lg flex items-center justify-between">
        <h3 className="text-lg font-semibold text-text-primary">
          Recent invoices
        </h3>
        <button
          className="flex items-center gap-xs font-semibold text-sm text-button-tertiary-color-fg cursor-pointer hover:text-button-tertiary-color-fg-hover"
          onClick={onSeeAll}
          type="button"
        >
          See all invoices
        </button>
      </div>
      <div className="rounded-xl border border-border-secondary bg-bg-primary p-xl">
        <p className="text-sm text-text-tertiary">Coming soon</p>
      </div>
    </div>
  );
}
